import ShopNow from '../shopNow';
import StyleAction from '../styleAction';
import constant from 'utils/constant';
import useAnalytics from '../hooks/useAnalytics';
import { getConversation_conversations_data_messages } from '../../../__generated__/getConversation';

const SuggestionsButtons = ({
    message,
    messageIndex,
    openedInfoMessage,
    setOpenedInfoMessage,
}: {
    message: getConversation_conversations_data_messages;
    messageIndex: number;
    openedInfoMessage: string | null;
    setOpenedInfoMessage: (state: string | null) => void;
}) => {
    const handleAnalytics = useAnalytics();
    const elements = message.elements;
    const element = elements && elements.length ? elements[0] : null;
    if (element) {
        return (
            <div className="suggestions-buttons">
                <div className={'suggestions-left-buttons'}>
                    <StyleAction
                        message={message}
                        element={{
                            ...element,
                            collectionName: element.collectionName || constant.COLLECTION_NAME.STYLES,
                        }}
                        openedInfoMessage={openedInfoMessage}
                        setOpenedInfoMessage={setOpenedInfoMessage}
                    />
                </div>
                <div className={'suggestions-right-buttons'}>
                    <ShopNow
                        element={element}
                        item={message}
                        handleAnalytics={handleAnalytics}
                        index={messageIndex}
                        elementIndex={0}
                        lastMessageIndex={0}
                        lastElementIndex={0}
                    />
                </div>
            </div>
        );
    } else {
        return null;
    }
};

export default SuggestionsButtons;
